var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression;

  return "    <a href=\""
    + alias1(container.lambda((depth0 != null ? depth0.downloadURI : depth0), depth0))
    + "\"\n        class=\"btn btn-primary btn-sm toolbar-menu-button content-download-button\">\n        <i class=\"fa fa-download\"></i>\n        "
    + alias1(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"data:content.download",{"name":"i18n","hash":{},"data":data}))
    + "\n    </a>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isHTTP : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression;

  return "        <a href=\""
    + alias1(container.lambda((depth0 != null ? depth0.uri : depth0), depth0))
    + "\" target=\"_blank\"\n            class=\"btn btn-primary btn-sm toolbar-menu-button content-openlink-button\">\n            <i class=\"fa fa-external-link\"></i>\n            "
    + alias1(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"data:content.openLink",{"name":"i18n","hash":{},"data":data}))
    + "\n        </a>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isEmpty : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(9, data, 0),"data":data})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    return "";
},"9":function(container,depth0,helpers,partials,data) {
    return "            <a href=\"javascript:void(0)\" class=\"btn btn-primary btn-sm content-copylink-button\">\n                <i class=\"fa fa-external-link\"></i>\n                "
    + container.escapeExpression(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"data:content.copyLink",{"name":"i18n","hash":{},"data":data}))
    + "\n            </a>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.downloadURI : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./data/ui/template/content/open-uri.hbs
// module id = 694
// module chunks = 0